/* istanbul ignore next */
const ACTIONS = {
    COMPLETED_TRIPBOARD_ONBOARDING: 'COMPLETED_TRIPBOARD_ONBOARDING',
    STARTED_TRIPBOARD_CREATION: 'STARTED_TRIPBOARD_CREATION',
    COMPLETED_TRIPBOARD_CREATION: 'COMPLETED_TRIPBOARD_CREATION',
    INIT_ONBOARDING_FLAGS: 'INIT_ONBOARDING_FLAGS',
    RESET_ONBOARDING_FLAGS: 'RESET_ONBOARDING_FLAGS'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    completeOnboarding: () => ({type: ACTIONS.COMPLETED_TRIPBOARD_ONBOARDING}),
    startTripboardCreation: () => ({type: ACTIONS.STARTED_TRIPBOARD_CREATION}),
    completeTripboardCreation: () => ({type: ACTIONS.COMPLETED_TRIPBOARD_CREATION}),
    resetOnBoardingFlags: () => ({type: ACTIONS.RESET_ONBOARDING_FLAGS}),
    initOnboardingFlags: (tripboardCreationStarted, tripboardCreationNotComplete, onboardingCompleted) => ({
        type: ACTIONS.INIT_ONBOARDING_FLAGS,
        payload: {tripboardCreationStarted, tripboardCreationNotComplete, onboardingCompleted}
    })
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/components/onboarding/actions.js